module.exports = __webpack_public_path__ + "static/media/PM2.8ed9fa21.JPG";